var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup158(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(-832 -3175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 67,
    height: 67,
    rx: 15,
    transform: "translate(832 3175)",
    fill: "#f6f6fa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "strategy",
    transform: "translate(845.914 3189.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M181.141,431.689l.588-.589-.816-.547H168.651l-.805.491.576.645,6.34.706Z",
    transform: "translate(-154.676 -396.77)",
    fill: "#ffba57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M165.24,445.036l-.847.7.554.757h13.306l.554-.757-.847-.7Z",
    transform: "translate(-151.494 -410.117)",
    fill: "#ffac3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M139.4,366.678l1.969.706,1.675-.706.293-1.458-1.783-.706-1.861.706Z",
    transform: "translate(-128.464 -335.913)",
    fill: "#d66e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M118.215,392.093l-1.8,8.923a.4.4,0,0,0,.4.485h2.818a.4.4,0,0,0,.4-.325l1.828-9.083h-3.644Z",
    transform: "translate(-107.277 -361.328)",
    fill: "#e8834d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M326.538,365.22l-1.675-.706-1.969.706.293,1.458,1.675.706,1.969-.706Z",
    transform: "translate(-297.559 -335.913)",
    fill: "#d66e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M332.074,401.018l-1.8-8.923h-3.644l1.828,9.083a.4.4,0,0,0,.4.325h2.818A.405.405,0,0,0,332.074,401.018Z",
    transform: "translate(-301.006 -361.33)",
    fill: "#e8834d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M213.936,13.322l3.3.706,3.3-.706V11.864l-3.3-.706-3.3.706Z",
    transform: "translate(-197.15 -10.283)",
    fill: "#d66e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M220.536,1.582V.81a.81.81,0,0,0-.81-.81h-4.981a.81.81,0,0,0-.81.81v.772Z",
    transform: "translate(-197.149)",
    fill: "#e8834d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M25.812,309.358l18.08.706,18.042-.706V307.9l-18.042-.706-18.08.706Z",
    transform: "translate(-23.787 -283.091)",
    fill: "#ecdaec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M61.934,60.509H25.812V40.359a1.62,1.62,0,0,1,1.62-1.62H60.314a1.62,1.62,0,0,1,1.62,1.62Z",
    transform: "translate(-23.787 -35.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M39.363,334.775H.81a.81.81,0,0,0-.81.81V337a.81.81,0,0,0,.81.81H39.363a.81.81,0,0,0,.81-.81v-1.42A.81.81,0,0,0,39.363,334.775Z",
    transform: "translate(0 -308.508)",
    fill: "#ffba57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M.81,337.063H39.363c.441,0,.809-.445.809-1.5,0,.006,0,.013,0,.019a.81.81,0,0,0-.81-.81H.81a.81.81,0,0,0-.81.81c0-.006,0-.013,0-.019,0,1.124.368,1.5.809,1.5Z",
    transform: "translate(0 -308.508)",
    fill: "#ffba57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M39.363,345.645H.81A.809.809,0,0,1,0,344.854c0,.006,0,.013,0,.019v1.42a.81.81,0,0,0,.81.81H39.363a.81.81,0,0,0,.81-.81v-1.42c0-.006,0-.013,0-.019A.81.81,0,0,1,39.363,345.645Z",
    transform: "translate(0 -317.796)",
    fill: "#ffac3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M105,100.775a3.563,3.563,0,1,0-3.857-3.9A3.741,3.741,0,0,0,105,100.775Z",
    transform: "translate(-93.209 -86.326)",
    fill: "#98db7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M249.721,237.166a1.83,1.83,0,1,0,3.653,0,1.967,1.967,0,0,0-3.653,0Z",
    transform: "translate(-230.127 -217.417)",
    fill: "#ff4755"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M249.9,252.941a1.967,1.967,0,0,1-1.827-1.238,1.967,1.967,0,1,0,3.653,0A1.967,1.967,0,0,1,249.9,252.941Z",
    transform: "translate(-228.481 -231.954)",
    fill: "#fc2b3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M104.2,137.61a3.926,3.926,0,0,1-3.857-3.2,3.925,3.925,0,1,0,7.713,0A3.926,3.926,0,0,1,104.2,137.61Z",
    transform: "translate(-92.403 -123.868)",
    fill: "#82d361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59",
    transform: "translate(9.335 8.539)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M123.673,121.62a.608.608,0,0,0-.861.011l-1.976,2.026-.83-.807a.609.609,0,1,0-.849.873l1.266,1.231a.609.609,0,0,0,.86-.011l2.4-2.462A.609.609,0,0,0,123.673,121.62Z",
    transform: "translate(-118.973 -120.457)",
    fill: "#f9f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(0.471 0.859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M128.736,236.063a.609.609,0,0,0-.861,0l-.932.932-.932-.932a.609.609,0,1,0-.861.861l.932.932-.932.932a.609.609,0,0,0,.861.861l.932-.932.932.932a.609.609,0,1,0,.861-.861l-.932-.932.932-.932A.609.609,0,0,0,128.736,236.063Z",
    transform: "translate(-124.972 -226.775)",
    fill: "#8bcaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M365.312,236.063a.609.609,0,0,0-.861,0l-.932.932-.932-.932a.609.609,0,1,0-.861.861l.932.932-.932.932a.609.609,0,0,0,.861.861l.932-.932.932.932a.609.609,0,0,0,.861-.861l-.932-.932.932-.932A.609.609,0,0,0,365.312,236.063Z",
    transform: "translate(-342.986 -226.775)",
    fill: "#8bcaff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M248.094,123.536a.609.609,0,0,0,.861,0l.932-.932.932.932a.609.609,0,0,0,.861-.861l-.932-.932.932-.932a.609.609,0,0,0-.861-.861l-.932.932-.932-.932a.609.609,0,1,0-.861.861l.932.932-.932.932A.609.609,0,0,0,248.094,123.536Z",
    transform: "translate(-238.269 -119.773)",
    fill: "#8bcaff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M223.321,116.165a.609.609,0,0,0,.49.707,15.867,15.867,0,0,0,2.611.2,11.835,11.835,0,0,0,6.929-1.93,7.863,7.863,0,0,0,3.1-5.637.609.609,0,0,0-1.208-.148,6.693,6.693,0,0,1-2.607,4.8c-3.3,2.433-8.553,1.524-8.605,1.514A.609.609,0,0,0,223.321,116.165Z",
    transform: "translate(-215.125 -108.823)",
    fill: "#ff4755"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup158);
export default __webpack_public_path__ + "static/media/Group 158.36eeb16cf6557323fe6934156d4618cc.svg";
export { ForwardRef as ReactComponent };